/* 如何更新相应的state,并且第一次读取store的state时自动触发,异步函数 */
/* 传参: { commit, action } */
import { api } from '@teacher/api';

export default {
  async roles({ commit }) {
    const res = await api.roleList();
    commit('roles', res.data);
  },
  async allCampusList({ commit }) {
    const res = await api.campusList({ type: '1' });
    commit('allCampusList', res.data);
  },
  async gradeList({ commit }) {
    const res = await api.getGradeList();
    commit('gradeList', res.data);
  },
  async companyList({ commit }) {
    const res = await api.getCompanyList();
    commit('companyList', res.data);
  },
  async comeFromList({ commit }) {
    const res = await api.getByFieldCode({
      businessType: 'STUDENT_INTENTION',
      fieldCode: 'come_from',
    });
    const comeFromList = [];
    const { displayList = [], selectItemList = [] } = res.data || {};
    if (displayList[0] && displayList[0].display > 0) {
      comeFromList.push(
        ...selectItemList.map((item) => ({
          id: item.id,
          name: item.itemName,
        })),
      );
    }
    commit('comeFromList', comeFromList);
  },
};
